// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"da0de079","239":"3d3ee951","732":"074975cf"}[chunkId] + ".chunk.js";
};